export default {
  name: 'DataTableKanbanMixin',

  methods: {
    /**
     * Hook to perform the load of extra tracker-related data and decorate the jsonLogic assertion
     * context; once API are loaded, call the setter on the kanban instance "this.$refs.kanban.setJlAssertionContext"
     */
    async fetchKanbanDataHook (trackerDTO) {
      this.$refs.kanban.setJlAssertionContext({})
    }
  }
}
